const DISPLAY_CREDENTIALS_KEY = 'tm-agenda-paired-display';

export const getPairedDisplayCredentials = () => {
  try {
    const value = window.localStorage.getItem(DISPLAY_CREDENTIALS_KEY);
    if (!value) return null;
    const credentials = JSON.parse(value);
    return credentials?.deviceId && credentials?.deviceToken ? credentials : null;
  } catch {
    return null;
  }
};

export const savePairedDisplayCredentials = (credentials) => {
  window.localStorage.setItem(DISPLAY_CREDENTIALS_KEY, JSON.stringify(credentials));
};

export const clearPairedDisplayCredentials = () => {
  window.localStorage.removeItem(DISPLAY_CREDENTIALS_KEY);
};
